import React from 'react'
import Top from '../components/home/Top';
import About from '../components/home/About';
import Team from '../components/home/Team';
import FAQ from '../components/home/FAQ';
import RoadMap from '../components/home/RoadMap';
import AISolutions from '../components/home/AISolutions';
import Contact from '../components/common/Contact';

function MainPage() {
  return (
    <>
    <Top />
    <About />
    <AISolutions />
    <RoadMap />
    <Team />
    <FAQ />
    <Contact />
    </>
  )
}

export default MainPage